// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  display: grid;
  grid-template-rows: auto 1fr auto;
  overflow: hidden;
  padding: 30px;
  height: 100%;
  width: 100%;
}

.toolbar {
  background-color: #41444d;
  height: 55px;
  color: white;
  font-size: 25px;
  justify-content: space-between;
}
.toolbar img {
  cursor: pointer;
}

.header {
  grid-row: 1;
}
.header .search {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.header .search .searchBtn {
  background-color: #217AD8;
  color: #F2F2F2;
}

mat-form-field {
  width: 100%;
}

.list {
  grid-row: 2;
  overflow: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.list .table-contaier {
  flex: 1;
  overflow-y: auto;
  width: 100%;
  height: 100%;
}
.list .radio, .list .complexId {
  width: 10%;
}
.list .desc {
  width: 80%;
}
.list tr {
  height: 80px;
}
.list .selected-row {
  background-color: #1395a7;
  font-weight: bold;
}

.footer {
  grid-row: 3;
  margin-top: auto;
}
.footer .button-bar {
  background-color: white;
  height: 55px;
  font-size: 25px;
  font-weight: 100;
  border-bottom: 1px solid #e7e7e7;
  display: flex;
  gap: 10px;
  justify-content: center;
}
.footer .button-bar button {
  min-width: 130px;
}
.footer .button-bar .ok {
  background-color: #217AD8;
  color: #F2F2F2;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/users-fgjs/add-object/add-object.component.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,iCAAA;EACA,gBAAA;EAEA,aAAA;EACA,YAAA;EACA,WAAA;AAFF;;AAKA;EACI,yBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,8BAAA;AAFJ;AAII;EACE,eAAA;AAFN;;AAMA;EACE,WAAA;AAHF;AAKE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAHJ;AAKI;EACE,yBAAA;EACA,cAAA;AAHN;;AAQA;EACE,WAAA;AALF;;AAQA;EACE,WAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AALF;AAOE;EACE,OAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AALJ;AAQE;EACE,UAAA;AANJ;AASE;EACE,UAAA;AAPJ;AAUE;EACE,YAAA;AARJ;AAWE;EACE,yBAAA;EACA,iBAAA;AATJ;;AAaA;EACE,WAAA;EACA,gBAAA;AAVF;AAYE;EACI,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;AAVN;AAYM;EACE,gBAAA;AAVR;AAaM;EACI,yBAAA;EACA,cAAA;AAXV","sourcesContent":["//@import \"../../../shared/table.scss\";\r\n\r\n.wrapper {\r\n  display: grid;\r\n  grid-template-rows: auto 1fr auto;\r\n  overflow: hidden;\r\n\r\n  padding: 30px;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.toolbar {\r\n    background-color: #41444d;\r\n    height: 55px;\r\n    color: white;\r\n    font-size: 25px;\r\n    justify-content: space-between;\r\n\r\n    img {\r\n      cursor: pointer;\r\n    }\r\n}\r\n\r\n.header {\r\n  grid-row: 1;\r\n\r\n  .search {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    .searchBtn {\r\n      background-color: #217AD8;\r\n      color: #F2F2F2;\r\n    }\r\n  }\r\n}\r\n\r\nmat-form-field {\r\n  width: 100%;\r\n}\r\n\r\n.list {\r\n  grid-row: 2;\r\n  overflow: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n\r\n  .table-contaier {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n\r\n  .radio, .complexId {\r\n    width: 10%;\r\n  }\r\n  \r\n  .desc {\r\n    width: 80%;\r\n  }\r\n  \r\n  tr {\r\n    height: 80px;\r\n  }\r\n\r\n  .selected-row {\r\n    background-color: #1395a7;\r\n    font-weight: bold;\r\n  }\r\n}\r\n\r\n.footer {\r\n  grid-row: 3;\r\n  margin-top: auto;\r\n\r\n  .button-bar {\r\n      background-color: white;\r\n      height: 55px;\r\n      font-size: 25px;\r\n      font-weight: 100;\r\n      border-bottom: 1px solid #e7e7e7;\r\n      display: flex;\r\n      gap: 10px;\r\n      justify-content: center;\r\n    \r\n      button {\r\n        min-width: 130px;\r\n      }\r\n\r\n      .ok {\r\n          background-color: #217AD8;\r\n          color: #F2F2F2;\r\n        }\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
